module.exports = __webpack_public_path__ + "img/tl.9482e698.svg";